var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.94858 2.10742C5.5621 2.10742 2 5.63497 2 9.99399C2 14.353 5.5621 17.8805 9.94858 17.8805C11.584 17.8805 13.1052 17.3901 14.3695 16.5491L19.555 21.6917C20.1145 22.2466 21.0202 22.2466 21.5797 21.6917C22.1412 21.1349 22.1412 20.2305 21.5797 19.6737L16.4274 14.564C17.3526 13.2749 17.8972 11.6972 17.8972 9.99399C17.8972 5.63497 14.3351 2.10742 9.94858 2.10742ZM4.86685 9.99399C4.86685 7.21595 7.13862 4.95778 9.94858 4.95778C12.7585 4.95778 15.0303 7.21595 15.0303 9.99399C15.0303 12.772 12.7585 15.0302 9.94858 15.0302C7.13862 15.0302 4.86685 12.772 4.86685 9.99399Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_8474_69362)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.107422,
  width: 24.0009,
  height: 24.0006,
  fill: "#00538F"
}));

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8474_69362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 21
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.46b110f4.svg";
export { ForwardRef as ReactComponent };